export var PROPS_LAYOUT = process.env.DOCPOC_PROPS_LAYOUT;
export var DEFAULT_SHOW_CODE = process.env.DOCPOC_SHOW_CODE;
export var DEFAULT_SHOW_IMPORTS = process.env.DOCPOC_HOW_IMPORTS;